import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaCrown } from "react-icons/fa";
import AuthContext from "../contexts/auth";

export default function FloatingPremiumButton() {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const isPremium = !!(
    user?.subscriptionExpiresAt &&
    new Date(user.subscriptionExpiresAt) > new Date()
  );

  // Não aparece para quem já é premium nem na própria landing /assine-agora.
  if (isPremium || location.pathname === "/assine-agora") return null;

  return (
    <Link to="/assine-agora" className="floating-premium-btn">
      <FaCrown className="floating-premium-crown" />
      <span>
        *Acesso livre a todos Cadernos do site durante um ano
      </span>
    </Link>
  );
}
